const reverseDate = (date, dilimiter) =>
  date
    .split(dilimiter)
    .reverse()
    .join(dilimiter);

export default reverseDate;
